<template>
    <mdb-col md="4" class="mt-3">
        <mdb-card wide>
            <mdb-view cascade v-if="iscompleted">
                <a v-on:click="gotoformation">
                    <mdb-card-image :src="image" alt="Card image cap" ></mdb-card-image>
                    <mdb-mask overlay="indigo-strong" pattern="6" class="flex-center"><h2 class="white-text">COMPLÉTÉ</h2></mdb-mask>
                </a>
            </mdb-view>
            <mdb-view hover cascade v-else>
                <a v-on:click="gotoformation">
                    <mdb-card-image :src="image" alt="Card image cap" ></mdb-card-image>
                    <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
                </a>
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
                <mdb-card-title><strong>{{title}}</strong></mdb-card-title>
                <h5 class="blue-text"><strong>Durée: {{duration}}</strong></h5>
                <mdb-card-text>
                    {{intro}}
                </mdb-card-text>
                <mdb-btn color="elegant" rounded v-on:click="gotoformation">Démarrer cette formation</mdb-btn>
            </mdb-card-body>
        </mdb-card>
    </mdb-col>
</template>

<script>
    import {
        mdbCol, mdbCard, mdbView, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbMask,
    } from 'mdbvue';

    export default {
        name: 'formationtile',
        props: {
            image: String,
            title: String,
            duration: String,
            intro: String,
            ident: String,
            iscompleted: Boolean,
        },
        components: {
            mdbCol,
            mdbCard,
            mdbView,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbBtn,
            mdbMask,
        },
        methods: {
            gotoformation() {
                const ident = `${this.ident}`;
                this.$router.push({ name: 'VideoDetails', params: { videoident: ident } });
            },
        },
    };
</script>
